import React from "react";

function CustomIcon() {
  return (
    <svg
      id="plant_2_"
      data-name="plant (2)"
      xmlns="http://www.w3.org/2000/svg"
      width="30.508"
      height="30.459"
      viewBox="0 0 30.508 30.459"
    >
      <g id="Group_3345" data-name="Group 3345" transform="translate(6.355 0)">
        <path
          id="Path_9981"
          data-name="Path 9981"
          d="M291.717,22.3a.636.636,0,0,0-.587-.393c-4.769,0-9.121,1.5-11.637,4.021a5.836,5.836,0,0,0,8.252,8.254c1.088-1.088,1.419-3.1,1.768-5.224.381-2.288.763-4.665,2.066-5.964A.636.636,0,0,0,291.717,22.3Z"
          transform="translate(-267.612 -20.628)"
          fill="#68b030"
        />
        <path
          id="Path_9982"
          data-name="Path 9982"
          d="M113.327,2.52a8.555,8.555,0,0,0-6.043-2.1.636.636,0,0,0-.45,1.086,5.466,5.466,0,0,1,.944,2.808,5.137,5.137,0,0,0,.974,2.785,3.236,3.236,0,1,0,4.576-4.576Z"
          transform="translate(-106.647 -0.407)"
          fill="#68b030"
        />
      </g>
      <path
        id="Path_9983"
        data-name="Path 9983"
        d="M205.9,108.051a.636.636,0,0,1-.615-.478c-.717-2.8-2.908-10.409-4.408-11.911a.636.636,0,0,1,.9-.9c1.5,1.5,3.231,7.06,4.139,10.27a25.222,25.222,0,0,1,5.893-9.507.636.636,0,0,1,.914.883l-.016.016a23.869,23.869,0,0,0-6.18,11.11.635.635,0,0,1-.605.516Z"
        transform="translate(-188.738 -88.973)"
        fill="#007a49"
      />
      <path
        id="Path_9984"
        data-name="Path 9984"
        d="M100.636,305.542a4.157,4.157,0,0,0-4.75-2.185l-4.112,1.028c-.183-1.59-1.128-2.523-3.008-2.992l-11.44-2.542a.636.636,0,0,0-.755.466l-1.907,7.627a.636.636,0,0,0,.416.763l9.509,3.17a7.287,7.287,0,0,0,2.634.636c1.289,0,2.8-.563,6.117-1.923l6.991-3.178a.635.635,0,0,0,.315-.842l-.01-.021Z"
        transform="translate(-70.196 -281.053)"
        fill="#ffe082"
      />
      <path
        id="Path_9985"
        data-name="Path 9985"
        d="M7.628,258.14a.636.636,0,0,0-.2-.517c-1.093-1.031-5.448-1.365-6.759-1.443a.651.651,0,0,0-.473.172.635.635,0,0,0-.2.464v11.44a.636.636,0,0,0,.636.636H4.45a.636.636,0,0,0,.605-.439A66.572,66.572,0,0,0,7.628,258.14Z"
        transform="translate(-0.001 -240.939)"
        fill="#455a64"
      />
      <path
        id="Path_9986"
        data-name="Path 9986"
        d="M208.762,388.579a4.44,4.44,0,0,1-.869-.085L203,387.515a.636.636,0,1,1,.254-1.246l4.891.979a3.221,3.221,0,0,0,1.4-.033l2.476-.619a1.271,1.271,0,0,1-.925,1.541l-1.244.311A4.428,4.428,0,0,1,208.762,388.579Z"
        transform="translate(-190.426 -363.266)"
        fill="#ffca28"
      />
    </svg>
  );
}

export default CustomIcon;
